import styled from 'styled-components';

export const WrapperDiv = styled.div`
  width: 100%;
  .login-error {
    font-size: 0.9em;
    color: var(--ion-color-danger);
    position: absolute;
    bottom: 0;
    margin-left: 15px;
  }

  ion-skeleton-text {
    width: 100%;
    margin-top: 1rem;
  }

  ion-item {
    --background: transparent;
  }

  ion-icon {
    position: absolute;
    right: 0;
  }
`;
